import { render, staticRenderFns } from "./GlobalSnackbar.vue?vue&type=template&id=33a4cfcb&"
import script from "./GlobalSnackbar.vue?vue&type=script&lang=js&"
export * from "./GlobalSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports